import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { HashRouter } from 'react-router-dom'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Provider } from 'react-redux'
import { store } from './starter/redux/store'
import { ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import ruRU from 'antd/locale/ru_RU'
import updateLocale from 'dayjs/plugin/updateLocale'
import minMax from 'dayjs/plugin/minMax'

const locale = ruRU
dayjs.extend(updateLocale)
dayjs.locale('ru')
dayjs.updateLocale('en', {
  weekStart: 1
})

dayjs.extend(minMax)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ConfigProvider locale={locale}>
      <DndProvider backend={HTML5Backend}>
        <Provider store={store}>
          <HashRouter basename='/'>
            <App />
          </HashRouter>
        </Provider>
      </DndProvider>
    </ConfigProvider>
  </React.StrictMode>
)
